import React from 'react';

function Details(props){
  return (
    <div>
    {props.details.map((details) => (
          <p>{details}</p>
      ))}
    </div>
  )
}

export default Details;
